import { formatType } from '@common/Filters/helpers/filters';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';

export const getNavigationItemUrl = (item, persistedFiltersGroup, filters, config) => {
    const { link } = item;
    const url = getTranslatedPropertyFromContext(item, 'url', config);
    const parts = [config.URLPrefix];

    if (link) {
        parts.push(link);
    } else if (url) {
        parts.push(url);
    }

    if (persistedFiltersGroup === item.persistFiltersGroup) {
        const filtersParts = [];

        if (filters && filters.length) {
            const filterObject = {};

            for (const { filterType, value } of filters) {
                const formattedType = formatType(filterType);

                if (filterObject[formattedType]) {
                    filterObject[formattedType] = [...filterObject[formattedType], value];
                } else {
                    filterObject[formattedType] = [value];
                }
            }

            Object.keys(filterObject).forEach((filterName) => {
                filtersParts.push([
                    filterName,
                    filterObject[filterName].join(',')
                ].join('='));
            });
        }

        if (filtersParts.length > 0) {
            parts.push([
                '?',
                filtersParts.join('&')
            ].join(''));
        }
    }

    return parts.join('');
};
